import { z } from 'zod';

export const VariableSchema = z.object({
  type: z.number().nullable(),
  name: z.string(),
  description: z.string(),
});
